export default "__VITE_ASSET__WvrUPjkA__"